import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {NavigationCancel, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs/internal/Subscription';
import {FlashAlertService} from "../../../../shared/services/flash-alert.service";

// import { DrawerComponent } from '../../../kt/components';
@Component({
  selector: 'app-content',
  host: {
    style: 'view-transition-name: content'
  },
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];

  private flashAlertService = inject(FlashAlertService)

  alertState = this.flashAlertService.getState();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.routingChanges();
  }

  routingChanges() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // DrawerComponent.hideAll();
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
